<template lang="pug">
v-app(dark v-resize="onResize")
  template-dashboard(v-if="$store.state.template=='dashboard'" style="height:100%")
  template-complete(v-else-if="$store.state.template=='complete'")
  template-centered(v-else-if="$store.state.template=='centered'")
  template-portada(v-else-if="$store.state.template=='portada'")
  template-portada-v2(v-else-if="$store.state.template=='portada-v2'")
  template-loading(v-else-if="$store.state.template=='loading'")
  template-default(v-else)
  vue-snotify
</template>

<script>
export default {
  name: 'App',
  data: () => ({
    some: process.env.VUE_APP_ENVIRONMENT,
  }),
  components: {
    'template-dashboard': () => import('@/components/templates/Dashboard'),
    'template-complete': () => import('@/components/templates/Complete.vue'),
    'template-centered': () => import('@/components/templates/Centered.vue'),
    'template-loading': () => import('@/components/templates/Loading.vue'),
    'template-portada': () => import('@/components/templates/Portada.vue'),
    'template-default': () => import('@/components/templates/Default.vue'),
    'template-portada-v2': () => import('@/components/templates/PortadaV2.vue'),
  },
  created() {
    //console.log('ENVIRONMENT :V', process.env.VUE_APP_ENVIRONMENT)
    
  },
  methods: {
    onResize() {
      this.$store.state.windowSize = {
        w: window.innerWidth,
        h: window.innerHeight,
        isMobile: window.innerWidth < 700 ? true : false
      };
    },
  },
};
</script>
